<template>
    <div id="add-webhook" class="td-edit-container one-step">
        <div class="pagination">
            <div class="form-name">
                <h3>Add Webhook</h3>
            </div>
            <div class="step-description">
                <div class="step active">
                    <p>Webhooks are website addresses you can register to receive automated messages from this system.</p>
                </div>
            </div>
        </div>
        <div class="edit-pages">
            <form>
                <h3>Add Webhook</h3>
                <div>
                    <div class="column">
                        <div class="mt-3">
                            <label class="td-label td-text-bold">URL:</label>
                            <input class="td-input" v-model="url" type="text" placeholder="Enter a secure url that will receive webhook POST requests" />
                            <div class="input-errors" v-for="error of validation.url.$errors" :key="error.$uid">
                                <div class="error-msg td-banner no-icon slim danger">{{ error.$message }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="mt-3">
                            <label class="td-label td-text-bold">Format:</label>
                            <select class="td-input" v-model="format">
                                <option value="Json">Json</option>
                                <option value="Microsoft Teams">Microsoft Teams</option>
                                <option value="Slack">Slack</option>
                            </select>
                        </div>
                    </div>
                </div>
            </form>

            <div class="actions">
                <div>
                    <button class="td-btn primary-outlined" @click.prevent="cancelClick">Cancel</button>
                </div>
                <div class="save-btn">
                    <button class="td-btn btn primary" @click.prevent="saveClick"><span v-if="isLoading"><icon name="faSpinner" type="solid" spin></icon>&nbsp;</span>Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import script from './AddWebhook';
    export default script;
</script>